import script from "./MediaflowEditorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowEditorPanel.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowEditorPanel.vue?vue&type=style&index=0&id=05a33353&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a33353"]])

export default __exports__